import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { BufferedTextInput } from 'record-it-components/input/TextInput/TextInput';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import {
  AnyPropertyChanged,
  useEntityPropertyChangedCallback
} from '../../../hooks/entity/useEntityPropertyChangedCallback';

export type EditTimeTrackingActivityCompilationFormProps = PropsWithoutChildren<
  ComponentProps<'div'>
> & {
  timeTrackingActivityCompilation: TimeTrackingActivityCompilation;
  onPropertyChanged: AnyPropertyChanged<TimeTrackingActivityCompilation>;
};

export const EditTimeTrackingActivityCompilationForm: FunctionComponent<EditTimeTrackingActivityCompilationFormProps> =
  React.memo((props) => {
    const {
      timeTrackingActivityCompilation,
      onPropertyChanged,
      ...remainingProps
    } = prepareProps({ props, ignoreChildren: true });

    const { t } = useTranslation();

    const handleNameChanged = useEntityPropertyChangedCallback(
      timeTrackingActivityCompilation,
      'name',
      onPropertyChanged
    );

    return (
      <div {...remainingProps}>
        <BufferedTextInput
          label={t('entities.TimeTrackingActivityCompilation.name')}
          value={timeTrackingActivityCompilation.name}
          onInput={handleNameChanged}
          data-testid="EditTimeTrackingActivityCompilationForm.NameInput"
        ></BufferedTextInput>
      </div>
    );
  });
